/* jshint esversion: 6 */
/* jshint esversion: 8 */
/* jshint esversion: 9 */
/* jshint ignore:start */
import React, { useState, useRef, useContext } from 'react';
import PhoneInput, { formatPhoneNumberIntl } from "react-phone-number-input";
import "react-phone-number-input/style.css";
import { showToast } from '../../showTost';
import Logo from "../../icon/Logo.svg";
import { MyContext } from '../../Context/MyProvider';
import axios from 'axios';
import secureLocalStorage from "react-secure-storage";
import { useTranslation } from 'react-i18next';
import { db, RecvestToken } from '../../Firebase/firebase';
import { doc, getDoc, setDoc } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';

const Signup = () => {

    const { t } = useTranslation();
    const { ApiBasUrl, setShowLoginPage, setShowSignupPage, setShowSelectCarPage, setIsLogin } = useContext(MyContext);

    const [isshow, setIsShow] = useState("Signup");
    const [value, setValue] = useState();
    const [password, setPassword] = useState("");
    const [Data, setData] = useState({ name: "", email: "", rcode: "" });
    const [passtype, setPassType] = useState("Password");
    const [selectremember, setSelectRemember] = useState(false);
    const [inputfiled, setInputFiled] = useState(Array(6).fill(""));
    const [sentotp, setSendOTP] = useState("");
    const [apiloading, setApiLoading] = useState(false);

    const [strength, setStrength] = useState(0);
    const strengthLabels = ['Weak', 'Fair', 'Great ✅', 'Very Great ✅'];

    const InputRef = useRef();
    const InputOtp = useRef(Array.from({ length: 6 }, () => null));

    const navigate = useNavigate();


    const updatePassword = (value) => {
        setPassword(value);
        setStrength(getCustomStrength(value));
    };

    function getCustomStrength(pw) {
        let score = 0;
        if (pw.length >= 8) score++;
        if (/[A-Z]/.test(pw)) score++;
        if (/[0-9]/.test(pw)) score++;
        if (/[^A-Za-z0-9]/.test(pw)) score++;
        return score;
    }

    const HandleChange = (value, index) => {
        const Copy = [...inputfiled];
        Copy[index] = value;
        setInputFiled(Copy);
        if (value && !isNaN(value) && index < InputOtp.current.length - 1) {
            InputOtp.current[index + 1].focus();
        }
    };

    const HandleonKeyDown = (e, index) => {
        if (e.key === "Backspace" && index > 0 && !e.target.value) {
            InputOtp.current[index - 1].focus();
        }
    };

    const HandleContinue = () => {

        if (apiloading) {
            return;
        }

        if (!Data.name || !Data.email) {
            showToast({ title: t("Please enter details !!"), id: "error" });
            return;
        }

        if (!value || !password) {
            showToast({ title: t("Please enter details !!"), id: "error" });
            return;
        }

        const emailValidation = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;

        if (!emailValidation.test(Data.email)) {
            showToast({ title: t("Please enter valid email !!"), id: "error" });
            return;
        }

        const Formattednumber = formatPhoneNumberIntl(value);
        const CountryCode = Formattednumber.split(" ")[0];
        const Number = Formattednumber.split(" ").splice(1);

        setApiLoading(true);

        axios.post(`${ApiBasUrl}/mobile_check.php`, { email: Data.email })
            .then((res) => {
                if (res.data.ResponseCode === "200") {
                    axios.post(`${ApiBasUrl}/mobile_check.php`, { mobile: Number.join(""), ccode: CountryCode })
                        .then((res) => {
                            if (res.data.ResponseCode === "200") {
                                axios.post(`${ApiBasUrl}/sms_type.php`)
                                    .then((res) => {
                                        if (res.data.otp_auth === "Yes") {
                                            if (res.data.SMS_TYPE === "Msg91") {
                                                HandleMsg91(Formattednumber);
                                            } else {
                                                HandleTwilio(Formattednumber);
                                            }
                                        } else {
                                            HandleSignup();
                                        }
                                    })
                                    .catch((error) => {
                                        console.error("sms_type.php", error);
                                    });
                            } else {
                                showToast({ title: res.data.ResponseMsg, id: "error" });
                                setApiLoading(false);
                            }
                        })
                        .catch((error) => {
                            console.error("mobile_check.php", error);
                        });
                } else {
                    showToast({ title: res.data.ResponseMsg, id: "error" });
                }
            })
            .catch((error) => {
                console.error("mobile_check.php", error);
            });
    };

    const HandleMsg91 = (mobile) => {
        axios.post(`${ApiBasUrl}/msg_otp.php`, { mobile })
            .then((res) => {
                if (res.data.ResponseCode === "200") {
                    showToast({ title: t("OTP send successfully !!"), id: "success" });
                    setSendOTP(res.data.otp);
                    setIsShow("OTP");
                    setApiLoading(false);
                }
            })
            .catch((error) => {
                console.error("msg_otp.php", error);
            });
    };

    const HandleTwilio = (mobile) => {
        axios.post(`${ApiBasUrl}/twilio_otp.php`, { mobile })
            .then((res) => {
                if (res.data.ResponseCode === "200") {
                    showToast({ title: t("OTP send successfully !!"), id: "success" });
                    setSendOTP(res.data.otp);
                    setIsShow("OTP");
                    setApiLoading(false);
                }
            })
            .catch((error) => {
                console.error("twilio_otp.php", error);
            });
    };

    const HandleConfirm = () => {
        if (sentotp === Number(inputfiled.join(""))) {
            HandleSignup();
            setApiLoading(true);
        } else {
            showToast({ title: t("OTP is invalid !!"), id: "error" });
        }
    };

    const HandleSignup = () => {

        secureLocalStorage.removeItem("Selectcar");
        secureLocalStorage.removeItem("Store");

        const FormattedNumber = formatPhoneNumberIntl(value);
        const ccode = FormattedNumber.split(" ")[0];
        const mobile = FormattedNumber.split(" ").splice(1).join("");

        const SignupData = {
            ...Data,
            password,
            ccode,
            mobile
        };

        axios.post(`${ApiBasUrl}/reg_user.php`, SignupData)
            .then((res) => {
                secureLocalStorage.setItem("Guest", false);
                showToast({ title: res.data.ResponseMsg, id: "success" });
                secureLocalStorage.setItem("LoginData", JSON.stringify(res.data.UserLogin));
                handleFirebaseUserAdd(res.data.UserLogin);
                secureLocalStorage.setItem("Userid", res.data.UserLogin.id);
                setShowSelectCarPage(true);
                setApiLoading(false);
                setShowSignupPage(false);
                setIsLogin("123");
                navigate("/");
            })
            .catch((error) => {
                console.error("reg_user.php", error);
            });
    };

    const handleFirebaseUserAdd = async (data) => {

        const FirebaseToken = await RecvestToken();

        const FirebaseData = {
            email: data.email,
            name: data.name,
            number: data.mobile,
            uid: data.id,
            pro_pic: "null",
            token: FirebaseToken
        };

        const userRef = doc(db, "GoMechProUser", data.id);

        getDoc(userRef)
            .then((docSnapshot) => {
                if (docSnapshot.exists()) {
                } else {
                    setDoc(userRef, FirebaseData);
                }
            });

    };

    return (
        <div>

            {isshow === "Signup" && <div className="py-[10px] px-[15px]">
                <div className="text-start">
                    <img src={Logo} className="w-[70px]" alt="" />
                    <h1 className=" text-[22px] font-bold leading-[22px] mb-[5px]">{t("Signup Account")} <br /> {t("to")} <span className="text-[#682afb]">{t("GoMechPro")}</span> </h1>
                    <span class="text-gray-500 text-[16px] font-[500]">{t("Hello there, signup to continue")}</span>
                </div>

                <div className="mt-[15px]">
                    <h1 className="text-start font-[500] text-[17px]">{t("Full Name")}</h1>
                    <div className="login-input focus-within:border-[#682afb] border-[2px]">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12.009 10.75C9.66503 10.75 7.75903 8.843 7.75903 6.5C7.75903 4.157 9.66503 2.25 12.009 2.25C14.353 2.25 16.259 4.157 16.259 6.5C16.259 8.843 14.353 10.75 12.009 10.75ZM12.009 3.75C10.492 3.75 9.25903 4.983 9.25903 6.5C9.25903 8.017 10.492 9.25 12.009 9.25C13.526 9.25 14.759 8.017 14.759 6.5C14.759 4.983 13.525 3.75 12.009 3.75ZM15.9969 21.75H8.00305C5.58305 21.75 4.25 20.425 4.25 18.019C4.25 15.358 5.756 12.25 10 12.25H14C18.244 12.25 19.75 15.357 19.75 18.019C19.75 20.425 18.4169 21.75 15.9969 21.75ZM10 13.75C6.057 13.75 5.75 17.017 5.75 18.019C5.75 19.583 6.42405 20.25 8.00305 20.25H15.9969C17.5759 20.25 18.25 19.583 18.25 18.019C18.25 17.018 17.943 13.75 14 13.75H10Z" fill="black" />
                        </svg>
                        <input value={Data?.name} onChange={(e) => setData({ ...Data, name: e.target.value })} type="text" className="bg-transparent px-[10px] w-[100%] outline-none" placeholder={t("Enter your full name...")} />
                    </div>
                </div>

                <div className="mt-[10px]">
                    <h1 className="text-start font-[500] text-[17px]">{t("Email Address")}</h1>
                    <div className="login-input focus-within:border-[#682afb] border-[2px]">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M18 20.75H6C3.582 20.75 2.25 19.418 2.25 17V8C2.25 5.582 3.582 4.25 6 4.25H18C20.418 4.25 21.75 5.582 21.75 8V17C21.75 19.418 20.418 20.75 18 20.75ZM6 5.75C4.423 5.75 3.75 6.423 3.75 8V17C3.75 18.577 4.423 19.25 6 19.25H18C19.577 19.25 20.25 18.577 20.25 17V8C20.25 6.423 19.577 5.75 18 5.75H6ZM13.0291 13.179L17.9409 9.60699C18.2759 9.36399 18.35 8.89401 18.106 8.55901C17.863 8.22501 17.3951 8.149 17.0581 8.394L12.146 11.966C12.058 12.03 11.941 12.03 11.853 11.966L6.94092 8.394C6.60292 8.149 6.13607 8.22601 5.89307 8.55901C5.64907 8.89401 5.72311 9.36299 6.05811 9.60699L10.97 13.18C11.278 13.404 11.639 13.515 11.999 13.515C12.359 13.515 12.7221 13.403 13.0291 13.179Z" fill="black" />
                        </svg>
                        <input type="text" value={Data?.email} onChange={(e) => setData({ ...Data, email: e.target.value })} className="bg-transparent px-[10px] w-[100%] outline-none" placeholder={t("Enter your email Address...")} />
                    </div>
                </div>

                <div className="mt-[10px]">
                    <h1 className="text-start font-[500] text-[17px]">{t("Mobile Number")}</h1>
                    <div className="relative login-input focus-within:border-[#682afb] border-[2px]">
                        <PhoneInput
                            className="w-[100%]"
                            ref={InputRef}
                            international
                            defaultCountry="IN"
                            value={value}
                            onChange={setValue}
                            name="phone"
                            style={{ outline: "none" }}
                        />

                        {!value && <h1 onClick={() => InputRef.current.focus()} className='absolute top-[10px] max-_430_:left-[60px] left-[80px] text-gray-400 whitespace-nowrap overflow-hidden overflow-ellipsis'>{t("Enter your mobile number...")}</h1>}
                    </div>
                </div>

                <div className="mt-[10px]">
                    <h1 className="text-start font-[500] text-[17px]">{t("Password")}</h1>
                    <div class="login-input focus-within:border-[#682afb] border-[2px]">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M16 8H8M16 8C18.2091 8 20 9.79086 20 12V18C20 20.2091 18.2091 22 16 22H8C5.79086 22 4 20.2091 4 18V12C4 9.79086 5.79086 8 8 8M16 8V6C16 3.79086 14.2091 2 12 2C9.79086 2 8 3.79086 8 6V8M14 15C14 16.1046 13.1046 17 12 17C10.8954 17 10 16.1046 10 15C10 13.8954 10.8954 13 12 13C13.1046 13 14 13.8954 14 15Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                        <input value={password} onChange={(e) => updatePassword(e.target.value)} className="bg-transparent px-[10px] w-[100%] outline-none" placeholder={t("Enter your password...")} type={passtype} />
                        {passtype === "Password"
                            ? <svg onClick={() => setPassType("text")} className="cursor-pointer" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M21.229 13.8679C19.913 16.0639 16.96 19.75 12 19.75C11.037 19.75 10.0861 19.604 9.17408 19.315C8.77908 19.19 8.56105 18.769 8.68605 18.374C8.81005 17.978 9.23496 17.762 9.62696 17.885C10.392 18.127 11.19 18.25 12 18.25C16.222 18.25 18.7901 15.02 19.9441 13.094C20.3521 12.418 20.3521 11.581 19.9461 10.907C19.6001 10.324 19.177 9.72798 18.72 9.17898C18.455 8.85998 18.4991 8.38707 18.8181 8.12307C19.1381 7.85807 19.61 7.90199 19.875 8.21999C20.381 8.82899 20.8509 9.49199 21.2329 10.137C21.9259 11.284 21.926 12.7159 21.229 13.8679ZM10.063 14.9981L3.53004 21.531C3.38404 21.677 3.19201 21.751 3.00001 21.751C2.80801 21.751 2.61598 21.678 2.46998 21.531C2.17698 21.238 2.17698 20.763 2.46998 20.47L5.64503 17.2949C4.31703 16.1499 3.35205 14.837 2.76905 13.866C2.07505 12.716 2.07501 11.2841 2.77101 10.1331C4.08701 7.93708 7.04001 4.251 12 4.251C13.835 4.251 15.565 4.76994 17.155 5.78494L20.469 2.47097C20.762 2.17797 21.237 2.17797 21.53 2.47097C21.823 2.76397 21.823 3.23901 21.53 3.53201L10.065 14.9971C10.065 14.9971 10.065 14.9981 10.064 14.9981C10.063 14.9981 10.063 14.9971 10.063 14.9981ZM9.6089 13.3311L13.3311 9.60891C12.9291 9.38191 12.478 9.251 12 9.251C10.484 9.251 9.25099 10.484 9.25099 12.001C9.25099 12.478 9.3829 12.9291 9.6089 13.3311ZM6.70704 16.232L8.51905 14.4199C8.02405 13.7169 7.75099 12.882 7.75099 11.999C7.75099 9.65605 9.65701 7.74905 12 7.74905C12.884 7.74905 13.7179 8.02211 14.4209 8.51711L16.052 6.88601C14.787 6.14501 13.432 5.74807 12 5.74807C7.77801 5.74807 5.20992 8.97808 4.05592 10.9041C3.64792 11.5801 3.64797 12.4171 4.05397 13.0911C4.59097 13.9881 5.48304 15.201 6.70704 16.232ZM14.708 12.4351C14.528 13.5951 13.594 14.53 12.436 14.709C12.027 14.772 11.7461 15.155 11.8091 15.564C11.8671 15.935 12.1861 16.2 12.5491 16.2C12.5871 16.2 12.6261 16.1969 12.6641 16.1909C14.4911 15.9089 15.908 14.4921 16.19 12.6641C16.253 12.2541 15.973 11.8721 15.563 11.8081C15.163 11.7471 14.771 12.0251 14.708 12.4351Z" fill="black" />
                            </svg>
                            : <svg onClick={() => setPassType("Password")} className="cursor-pointer" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M21.2352 10.1379C19.9222 7.93894 16.9751 4.25 12.0001 4.25C7.02511 4.25 4.07801 7.93894 2.76501 10.1379C2.07801 11.2859 2.07801 12.7131 2.76501 13.8621C4.07801 16.0611 7.02511 19.75 12.0001 19.75C16.9751 19.75 19.9222 16.0611 21.2352 13.8621C21.9222 12.7131 21.9222 11.2869 21.2352 10.1379ZM19.9481 13.092C18.7981 15.018 16.2351 18.25 12.0001 18.25C7.76511 18.25 5.20212 15.019 4.05212 13.092C3.65012 12.418 3.65012 11.581 4.05212 10.907C5.20212 8.98098 7.76511 5.74902 12.0001 5.74902C16.2351 5.74902 18.7981 8.97998 19.9481 10.907C20.3511 11.582 20.3511 12.418 19.9481 13.092ZM12.0001 7.75C9.65611 7.75 7.75011 9.657 7.75011 12C7.75011 14.343 9.65611 16.25 12.0001 16.25C14.3441 16.25 16.2501 14.343 16.2501 12C16.2501 9.657 14.3441 7.75 12.0001 7.75ZM12.0001 14.75C10.4831 14.75 9.25011 13.517 9.25011 12C9.25011 10.483 10.4831 9.25 12.0001 9.25C13.5171 9.25 14.7501 10.483 14.7501 12C14.7501 13.517 13.5171 14.75 12.0001 14.75Z" fill="black" />
                            </svg>
                        }
                    </div>
                    <div className="flex items-center gap-[5px]">
                        {[0, 1, 2, 3].map((index) => (
                            <div
                                key={index}
                                className={`flex-1 h-[5px] rounded-full mt-[5px] transition-all duration-300 ${password && index <= strength ? 'bg-green-500' : 'bg-gray-300'}`}></div>
                        ))}
                    </div>
                    <h1 className="text-start mt-[5px]">{t("Password strength")} : {t(password && strengthLabels[strength])}</h1>
                </div>

                <div className="mt-[10px]">
                    <h1 className="text-start font-[500] text-[17px]">{t("Referral code")}</h1>
                    <div className="login-input focus-within:border-[#682afb] border-[2px]">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M19.5 6.25H18.4351C18.6291 5.873 18.75 5.452 18.75 5C18.75 3.484 17.517 2.25 16 2.25C15.178 2.25 14.405 2.61599 13.874 3.26099C13.847 3.29499 12.723 4.78898 12 5.75098C11.276 4.78798 10.151 3.29199 10.119 3.25299C9.59502 2.61499 8.822 2.25 8 2.25C6.483 2.25 5.25 3.484 5.25 5C5.25 5.452 5.36994 5.873 5.56494 6.25H4.5C3.26 6.25 2.25 7.259 2.25 8.5V12C2.25 12.414 2.586 12.75 3 12.75H3.25V18C3.25 20.418 4.582 21.75 7 21.75H17C19.418 21.75 20.75 20.418 20.75 18V12.75H21C21.414 12.75 21.75 12.414 21.75 12V8.5C21.75 7.259 20.74 6.25 19.5 6.25ZM20.25 8.5V11.25H12.75V7.75H16H19.5C19.913 7.75 20.25 8.086 20.25 8.5ZM15.0389 4.20697C15.2809 3.91297 15.622 3.75 16 3.75C16.689 3.75 17.25 4.311 17.25 5C17.25 5.689 16.689 6.25 16 6.25H13.502C14.177 5.352 14.9919 4.26797 15.0389 4.20697ZM6.75 5C6.75 4.311 7.311 3.75 8 3.75C8.378 3.75 8.719 3.91198 8.948 4.19098C9.003 4.26198 9.82105 5.35 10.498 6.25H8C7.311 6.25 6.75 5.689 6.75 5ZM3.75 8.5C3.75 8.086 4.087 7.75 4.5 7.75H8H11.25V11.25H3.75V8.5ZM4.75 18V12.75H11.25V20.25H7C5.423 20.25 4.75 19.577 4.75 18ZM19.25 18C19.25 19.577 18.577 20.25 17 20.25H12.75V12.75H19.25V18Z" fill="black" />
                        </svg>
                        <input value={Data?.rcode} onChange={(e) => setData({ ...Data, rcode: e.target.value })} type="text" className="bg-transparent px-[10px] w-[100%] outline-none" placeholder={t("Enter your referral code (Optional)")} />
                    </div>
                </div>

                <div className="mt-[10px]">
                    <div onClick={() => setSelectRemember(!selectremember)} className="flex items-center gap-[10px] cursor-pointer">
                        <div className={`border-[2px] border-[#682afb] ${selectremember && "bg-[#682afb]"} rounded-[5px]`}>
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M9 17.75C8.999 17.75 8.99799 17.75 8.99699 17.75C8.79699 17.749 8.60599 17.669 8.46499 17.526L4.46499 13.464C4.17399 13.169 4.178 12.694 4.473 12.403C4.768 12.113 5.24399 12.116 5.53399 12.411L9.003 15.935L18.469 6.46902C18.762 6.17602 19.237 6.17602 19.53 6.46902C19.823 6.76202 19.823 7.23705 19.53 7.53005L9.53 17.5301C9.39 17.6711 9.199 17.75 9 17.75Z" fill="white" />
                            </svg>
                        </div>
                        <h1 className="text-[16px] select-none">{t("I agree to the")} <span className="text-[#682afb]">{t("Terms & Conditions & Privacy policy")}</span>
                        </h1>
                    </div>
                </div>

                <button onClick={HandleContinue} className="button mt-[10px] rounded-[50px]">
                    {apiloading
                        ? <div className="loader mx-auto"></div>
                        : <span>{t("Create Account")}</span>
                    }
                </button>
                <h1 onClick={() => { setShowSignupPage(false); setShowLoginPage(true) }} class="mt-[10px] text-center text-[#682afb] underline cursor-pointer">{t("I already have an account")}</h1>

            </div>}

            {isshow === "OTP" && <div className="py-[10px] px-[15px]">
                <div className="text-center">
                    <h1 className="font-bold text-[20px]">{t("OTP Code Verification")}</h1>
                    <p className="font-[500] text-gray-400 leading-4 mt-[10px]">{t("We have sent an OTP code to your mobile")} <br /> {t("number")} {value}</p>
                    <span>{t("Your OTP")} :- {sentotp}</span>
                </div>
                <div className="mt-[15px] flex items-center gap-[10px] justify-center">
                    {inputfiled.map((item, index) => {
                        return <input
                            key={index}
                            value={item}
                            ref={(e) => InputOtp.current[index] = e}
                            onChange={(e) => HandleChange(e.target.value, index)}
                            onKeyDown={(e) => HandleonKeyDown(e, index)}
                            className="w-[50px] text-center min-h-[45px] focus-within:border-[#682afb] outline-none rounded-[50px] border-[1px] bg-gray-100"
                            type="text"
                            maxLength="1"
                        />
                    })}
                </div>
                <button onClick={HandleConfirm} className="button rounded-[50px] mt-[20px]">
                    {apiloading
                        ? <div className="loader mx-auto"></div>
                        : <span>{t("Confirm")}</span>
                    }
                </button>
            </div>}

        </div>
    )
}

export default Signup;
/* jshint ignore:end */